import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import TrendingProducts from './pages/TrendingProducts';
import TrendingProductForm from './pages/TrendingProductForm';
import Categories from './pages/Categories';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Users from './pages/Users';
import Customers from './pages/Customers';
import Promotions from './pages/Promotions';
import Sales from './pages/Sales';
import WatchVideos from './pages/WatchVideos';
import Settings from './pages/Settings';
import GiftBoxes from './pages/GiftBoxes';
import PendingProducts from './pages/PendingProducts';
import SellersManagement from './pages/SellersManagement';
import PendingSellers from './pages/PendingSellers';
import VerifiedSellers from './pages/VerifiedSellers';
import SellerPerformance from './pages/SellerPerformance';
import Reviews from './pages/Reviews';
import PromotionRequests from './pages/PromotionRequests';
import HeroProductRequests from './pages/HeroProductRequests';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <Box sx={{ display: 'flex' }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/trending" element={<TrendingProducts />} />
                  <Route path="/trending-products/new" element={<TrendingProductForm />} />
                  <Route path="/trending-products/:id/edit" element={<TrendingProductForm />} />
                  <Route path="/products/new" element={<ProductForm />} />
                  <Route path="/products/:id/edit" element={<ProductForm />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/orders/:id" element={<OrderDetail />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/customers" element={<Customers />} />
                  <Route path="/promotions" element={<Promotions />} />
                  <Route path="/promotion-requests" element={<PromotionRequests />} />
                  <Route path="/hero-product-requests" element={<HeroProductRequests />} />
                  <Route path="/sales" element={<Sales />} />
                  <Route path="/watch-videos" element={<WatchVideos />} />
                  <Route path="/gift-boxes" element={<GiftBoxes />} />
                  <Route path="/pending-products" element={<PendingProducts />} />
                  <Route path="/sellers" element={<SellersManagement />} />
                  <Route path="/sellers/pending" element={<PendingSellers />} />
                  <Route path="/sellers/verified" element={<VerifiedSellers />} />
                  <Route path="/sellers/performance" element={<SellerPerformance />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Box>
  );
}

export default App;


